import UseGetUser from "helpers/useGetUser";
import React, { useCallback, useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";

import auth from "shared/Auth0";

export default function Auth0Callback() {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<boolean | string | null>(null);
  const { data: user, refetch } = UseGetUser(!isLoading);

  const handleAuth = useCallback(async () => {
    return await auth.handleAuthentication();
  }, []);

  useEffect(() => {
    const onAuth = async () => {
      try {
        await handleAuth();
        setIsLoading(false);
        refetch();
      } catch (e) {
        setError(e instanceof Error ? e.message : "Error logging in");
      }
    };

    onAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error) {
    return (
      <div>
        <pre>{JSON.stringify(error, null, 2)}</pre>
        <Link to="/logout">Logout</Link>
      </div>
    );
  }
  if (user) {
    return <Navigate to={"/"} />;
  }

  return (
    <div className="flex items-center justify-center h-screen">Logging in</div>
  );
}
